"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderMainItemImage = void 0;
const TSalesOrderItemType_1 = require("../types/TSalesOrderItemType");
const getOrderMainItemImage = (salesOrderItems) => {
    // no items in order therefore no image
    if (!salesOrderItems) {
        return null;
    }
    // empty items no image to choose from
    if (Array.isArray(salesOrderItems) && salesOrderItems.length === 0) {
        return null;
    }
    // find the first build product in the sales order and use that as the
    // main identifying image
    const builtProduct = salesOrderItems.find((salesOrderItem) => salesOrderItem.type === TSalesOrderItemType_1.TSalesOrderItemType.Built);
    if (builtProduct !== undefined) {
        return builtProduct.image;
    }
    // only stocked products so just return the image of the first one
    return salesOrderItems[0].image;
};
exports.getOrderMainItemImage = getOrderMainItemImage;
//# sourceMappingURL=getOrderMainItemImage.js.map